import React from "react";
import './Wrapper.css';

export default function Wrapper({children}) {
	return <div className={'wrapper'}>{children}</div>;
}